export type GQLNull = null | undefined
export const GQLNullValue = null
export type ReactNull = null | undefined
export const ReactNullValue = null
